import styled from 'styled-components'

export const ContainerAccordion = styled.div`
  .accordion {
    max-width: 100%;
  }
  .accordion:focus-within:not(.accordion--disabled) {
    outline: 0px;
    outline-offset: 0px;
  }
  .accordion:hover {
    background-color: transparent;
  }
  .accordion__summary-text {
    span + span {
      color: var(--color-text-neutral-secondary);
    }
  }
  .accordion {
    --content-max-width: 100%;
    --accordion-container-min-width: 100%;
  }
`
